import { Gift } from "lucide-react";
import ProductCard from "./ProductCard";
import { Reveal } from "./Reveal";

export default function GiftSets({ products, currency, onOpen }) {
  const sets = products.filter((p) => p.is_giftset);
  if (!sets.length) return null;

  return (
    <section
      id="sets"
      data-testid="giftsets-section"
      className="bg-surface py-24 md:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.3em] text-rose">
            <Gift size={14} /> Para regalar
          </span>
          <h2 className="mt-4 font-serif font-light text-4xl md:text-6xl leading-none">
            Sets de <span className="italic text-rose">regalo</span>
          </h2>
          <p className="text-taupe mt-5 font-light">
            Combos de mini perfumes a precio especial. La sorpresa perfecta para el Día
            de las Madres, cumpleaños o solo porque sí.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 lg:grid-cols-3 gap-x-5 gap-y-12 md:gap-x-8">
          {sets.map((p) => (
            <ProductCard key={p.id} product={p} currency={currency} onOpen={onOpen} />
          ))}
        </div>
      </div>
    </section>
  );
}
